import {fetchTopSchools} from "Services/BellLogService";

// Leaderboard period tabs and the anchor date sent to the backend, which
// derives the day / week / month / year range from it.
export const LEADERBOARD_PERIODS = [
    {key: "DAILY", label: "Daily"},
    {key: "WEEKLY", label: "Weekly"},
    {key: "MONTHLY", label: "Monthly"},
    {key: "YEARLY", label: "Yearly"},
];

// Local (not UTC) YYYY-MM-DD for today, matching the backend's LocalDate param.
export function todayISO() {
    const d = new Date();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${mm}-${dd}`;
}

// "Top schools by bell usage" leaderboard for the admin dashboard.
//
// Backed by GET /bell-log/top-schools?period=&date=&limit=N, which returns rows
// of { schoolId, schoolName, schoolLogo, schoolAddress, bellsPlayed }. The
// current date is sent as the anchor so the backend scopes to the current
// day/week/month/year for the chosen period. We normalise the rows into the
// shape the TopSchools table renders and sort by plays (defensively, in case
// the backend order ever changes).
export async function fetchTopSchoolsByBellUsage(limit = 10, period = "DAILY", date = todayISO()) {
    const response = await fetchTopSchools(limit, period, date || todayISO());
    const rows = Array.isArray(response?.data) ? response.data : response?.data?.content || [];

    return rows
        .map((row) => ({
            schoolId: row.schoolId ?? null,
            name: row.schoolName || "Unknown School",
            logo: row.schoolLogo || null,
            address: row.schoolAddress || "—",
            bellsPlayed: row.bellsPlayed || 0,
            // Total scheduled bells for the period (used to show played/total on the Daily tab).
            totalBells: row.totalBells ?? row.totalBell ?? 0,
            daysPlayed: row.daysPlayed || 0,
        }))
        .sort((a, b) => b.bellsPlayed - a.bellsPlayed)
        .slice(0, limit);
}
